import jwtDecode from 'jwt-decode';
import api from './apiService';
import { isEmpty } from '../utils/helpers';
// import setSentryUser from '../actions/setSentryUser';
import * as storage from '../storage';

const tokenKey = 'token';

export function getToken() {
  return storage.local.getItem(tokenKey);
}

export function login(email, password) {
  const params = { password };
  const isPhone = /^\d+$/.test(email);
  if (isPhone) {
    params.phone = email;
  } else {
    params.email = email;
  }
  return api.post('/login', params);
}
export function getCurrentUser() {
  try {
    const jwt = storage.local.getItem(tokenKey);
    return jwtDecode(jwt);
  } catch (ex) {
    return null;
  }
}
export function isTokenExpired() {
  try {
    const token = getToken();
    const { exp } = jwtDecode(token);
    return exp < (Date.now() / 1000);
  } catch (ex) {
    return true;
  }
}
export function isAuthenticated() {
  try {
    const token = storage.local.getItem(tokenKey);
    const validToken = jwtDecode(token);
    const isExpired = isTokenExpired();
    if (!isEmpty(token) && !isExpired && validToken) {
      // setSentryUser(validToken.email);
      return true;
    }
    return false;
  } catch (ex) {
    return false;
  }
}

export function profile() {
  return api.get('/whoami');
}

export default {
  isTokenExpired,
  login,
  getCurrentUser,
  getToken,
  profile,
  isAuthenticated,
};
